var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"external-frame"},[_c('iframe',{ref:"externalIframe",staticClass:"external-frame__iframe",attrs:{"src":_vm.externalUrl,"frameborder":"0"},on:{"load":_vm.onIframeLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }